<template>
  <view class="container">
    <!-- 渐变背景容器 -->
    <view class="gradient-background">
      <!-- 自定义导航栏 -->
      <view class="custom-nav">
        <view :style="{ height: statusbarHeight + 'px' }"></view>
        <view class="nav-content" :style="{ height: navHeight + 'px' }">
          <text class="nav-title">中铁快运南站旗舰店</text>
        </view>
      </view>

      <!-- 数据统计 -->
    <view class="stats-section" :style="{ backgroundImage: 'url(' + bgImg + ')' }">
      <view class="stats-tabs">
        <text class="tab-item active">今日</text>
        <text class="tab-item">本月</text>
        <text class="tab-item">上月</text>
        <text class="tab-item right">在库订单: 10</text>
      </view>
      
      <view class="stats-cards">
        <view class="stat-card">
          <text class="stat-label">销售额(元)</text>
          <text class="stat-value">12,000.00</text>
        </view>
        <view class="stat-card">
          <text class="stat-label">结算利润(元)</text>
          <text class="stat-value">1,200.00</text>
        </view>
        <view class="stat-card">
          <text class="stat-label">订单数</text>
          <text class="stat-value">23</text>
        </view>
      </view>
    </view>
    </view>

    <!-- 功能按钮 -->
    <view class="function-buttons">
      <view class="func-btn">
        <image class="func-icon" src="/static/icon/ic_zitihexiao@2x.png"></image>
        <text class="func-text">门店出入库</text>
      </view>
      <view class="func-btn">
        <image class="func-icon" src="/static/icon/ic_dingdanguanli@2x.png"></image>
        <text class="func-text">订单管理</text>
      </view>
      <view class="func-btn">
        <image class="func-icon" src="/static/icon/ic_wodezizhi@2x.png"></image>
        <text class="func-text">门店信息</text>
      </view>
      <view class="func-btn">
        <image class="func-icon" src="/static/icon/ic_wodezizhi@2x.png"></image>
        <text class="func-text">门店资质</text>
      </view>
    </view>

    <!-- 待处理订单 -->
    <view class="orders-section">
      <!-- <text class="section-title">待处理订单(2)</text> -->
      
      <view class="order-item">
        <view class="order-header">
          <view class="order-tag">就地寄存</view>
          <text class="order-user">李明 181****1898</text>
          <text class="order-status">待核验</text>
        </view>
        
        <view class="order-items">
          <view class="order-product">
          <view class="product-info">
            <text class="product-name">大件行李箱</text>
            <text class="product-spec">24-28寸</text>
          </view>
          <view class="product-price-count">
            <text class="product-price">¥35</text>
            <text class="product-count">x1</text>
          </view>
        </view>
        <view class="order-product">
          <view class="product-info">
            <text class="product-name">中件行李箱</text>
            <text class="product-spec">24-28寸</text>
          </view>
          <view class="product-price-count">
            <text class="product-price">¥35</text>
            <text class="product-count">x1</text>
          </view>
        </view>
        </view>
        
        <view class="order-footer">
          <text class="total-price">实付款: ¥80.00</text>
          <view class="order-buttons">
            <button class="btn btn-secondary">联系客户</button>
            <button class="btn btn-primary">扫码核销</button>
          </view>
        </view>
        
        <text class="order-note">订单备注: 13:30来寄存</text>
      </view>

      <view class="order-item">
        <view class="order-header">
          <view class="order-tag">就地寄存</view>
          <text class="order-user">张杰 151****7678</text>
          <text class="order-status">待取件</text>
        </view>
        
        <view class="order-items">
          <view class="order-product">
            <text class="product-name">大件行李箱</text>
            <text class="product-spec">24-28寸</text>
            <text class="product-price">¥35</text>
            <text class="product-count">x1</text>
          </view>
          <view class="order-product">
            <text class="product-name">中件行李箱</text>
            <text class="product-spec">24-28寸</text>
            <text class="product-price">¥35</text>
            <text class="product-count">x1</text>
          </view>
        </view>
        
        <view class="order-footer">
          <text class="total-price">实付款: ¥70.00</text>
          <view class="order-buttons">
            <button class="btn btn-secondary">联系客户</button>
            <button class="btn btn-primary">扫码核销</button>
          </view>
        </view>
        
        <text class="order-note">订单备注: -</text>
      </view>
      <view class="order-item">
        <view class="order-header">
          <view class="order-tag">就地寄存</view>
          <text class="order-user">张杰 151****7678</text>
          <text class="order-status">待取件</text>
        </view>
        
        <view class="order-items">
          <view class="order-product">
            <text class="product-name">大件行李箱</text>
            <text class="product-spec">24-28寸</text>
            <text class="product-price">¥35</text>
            <text class="product-count">x1</text>
          </view>
          <view class="order-product">
            <text class="product-name">中件行李箱</text>
            <text class="product-spec">24-28寸</text>
            <text class="product-price">¥35</text>
            <text class="product-count">x1</text>
          </view>
        </view>
        
        <view class="order-footer">
          <text class="total-price">实付款: ¥70.00</text>
          <view class="order-buttons">
            <button class="btn btn-secondary">联系客户</button>
            <button class="btn btn-primary">扫码核销</button>
          </view>
        </view>
        
        <text class="order-note">订单备注: -</text>
      </view>
    </view>
  </view>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['navHeight', 'statusbarHeight'])
  },
  data() {
    return {
        bgImg: require('@/static/image/bg_card@2x.png'),
      orders: [
        {
          id: 1,
          user: '李明 181****1898',
          status: '待核验',
          products: [
            { name: '大件行李箱', spec: '24-28寸', price: 35, count: 1 },
            { name: '中件行李箱', spec: '24-28寸', price: 35, count: 1 }
          ],
          total: 80.00,
          note: '13:30来寄存'
        },
        {
          id: 2,
          user: '张杰 151****7678',
          status: '待取件',
          products: [
            { name: '大件行李箱', spec: '24-28寸', price: 35, count: 1 },
            { name: '中件行李箱', spec: '24-28寸', price: 35, count: 1 }
          ],
          total: 70.00,
          note: '-'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
$bg-color: #f5f5f5;
$primary-color: #1677ff;
$success-color: #52c41a;
$danger-color: #ff4d4f;
$text-color: #333;
$text-secondary-color: #666;
$text-tertiary-color: #999;

.container {
  background-color: $bg-color;
  min-height: 100vh;
}

/* 渐变背景容器 */
.gradient-background {
  background: #C8F3FF;
  color: #1a1a1a;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to bottom, transparent, #ffffff);
  }
}

/* 自定义导航栏 */
.custom-nav {
  color: #1a1a1a;
}

.nav-content {
  display: flex;
  align-items: center;
  padding: 0 20rpx;
}

.nav-title {
  font-size: 32rpx;
  font-weight: bold;
}

.stats-section {
  height: 256rpx;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.stats-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20rpx;
  position: relative;
  z-index: 1;
}

.tab-item {
  font-size: 28rpx;
  color: #91d5ff;

  &.active {
    color: white;
    font-weight: bold;
  }

  &.right {
    color: white;
  }
}

.stats-cards {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.stat-card {
  flex: 1;
  text-align: center;
}

.stat-label {
  display: block;
  font-size: 24rpx;
  color: #91d5ff;
  margin-bottom: 10rpx;
}

.stat-value {
  display: block;
  font-size: 36rpx;
  font-weight: bold;
  color: white;
}

.function-buttons {
  background-color: white;
  margin: 0 20rpx 20rpx;
  border-radius: 12rpx;
  padding: 30rpx;
  display: flex;
  justify-content: space-between;
}

.func-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120rpx;
}

.func-icon {
  width: 80rpx;
  height: 80rpx;
  margin-bottom: 10rpx;
}

.func-text {
  font-size: 24rpx;
  color: $text-secondary-color;
}

.orders-section {
  background-color: white;
  margin: 0 20rpx 20rpx;
  border-radius: 12rpx;
  padding: 20rpx;
}

.section-title {
  font-size: 32rpx;
  font-weight: bold;
  color: $text-color;
  margin-bottom: 20rpx;
  display: block;
}

.order-item {
  border-bottom: 1rpx solid #eee;
  padding: 20rpx 0;

  &:last-child {
    border-bottom: none;
  }
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20rpx;
  flex-wrap: wrap;
}

.order-tag {
  background-color: $success-color;
  color: white;
  padding: 8rpx 16rpx;
  border-radius: 20rpx;
  font-size: 24rpx;
}

.order-user {
  font-size: 28rpx;
  color: $text-color;
}

.order-status {
  font-size: 28rpx;
  color: $danger-color;
}

.order-product {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30rpx;
}

.product-info {
  flex: 3;
}

.product-name {
  font-size: 28rpx;
  color: $text-color;
  display: block;
}

.product-spec {
  font-size: 24rpx;
  color: $text-tertiary-color;
  display: block;
  margin-top: 5rpx;
}

.product-price-count {
  flex: 1;
  text-align: right;
}

.product-price {
  font-size: 28rpx;
  color: $danger-color;
  display: block;
}

.product-count {
  font-size: 24rpx;
  color: $text-tertiary-color;
  display: block;
  margin-top: 5rpx;
}

.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30rpx 0;
}

.total-price {
  font-size: 28rpx;
  color: $text-color;
  font-weight: bold;
}

.order-buttons {
  display: flex;
  gap: 20rpx;
}

.btn {
  padding: 20rpx 40rpx;
  border-radius: 40rpx;
  font-size: 28rpx;
  border: none;

  &.secondary {
    background-color: white;
    color: $primary-color;
    border: 2rpx solid $primary-color;
  }

  &.primary {
    background-color: $primary-color;
    color: white;
  }
}

.order-note {
  font-size: 24rpx;
  color: $text-tertiary-color;
  background-color: $bg-color;
  padding: 20rpx;
  border-radius: 8rpx;
  margin-top: 20rpx;
}
</style>